import React from 'react';
import styled from 'styled-components';
/* 
  SkeletonPulse is a component to be used as a BASE for other skeleton components.
  Essentially it renders the animation of the skeleton.

  SkeletonLine is an example of a component using SkeletonPulse.
*/

var SkeletonPulseWrapper = styled.span.withConfig({
  displayName: "SkeletonPulse__SkeletonPulseWrapper",
  componentId: "sc-17kmue2-0"
})(["\n  height: 100%;\n  width: 100%;\n  display: inline-block;\n  background: linear-gradient(-90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%);\n  background-size: 400% 400%;\n  animation: pulse 1.2s ease-in-out infinite;\n  @keyframes pulse {\n    0% {\n      background-position: 0% 0%;\n    }\n    100% {\n      background-position: -135% 0%;\n    }\n  }\n"]);

var SkeletonPulse = props => {
  return /*#__PURE__*/React.createElement(SkeletonPulseWrapper, props);
};

export default SkeletonPulse;